import * as React from 'react';
import { useMemo } from 'react';

import { Intent } from '@blueprintjs/core';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

import { ImportantIntentColors, IntentColors } from './StatusConsts';
import type { StatusIntent } from './StatusConsts';

import './StatusDot.scss';

export interface StatusDotProps extends React.PropsWithChildren<{}> {
  className?: string;
  iconProps?: Partial<FontAwesomeIconProps>;
  important?: boolean;
  status?: StatusIntent;
}

export const StatusDot: React.FC<StatusDotProps> = ({
  children,
  iconProps,
  important,
  status,
  className,
}) => {
  const colors = useMemo(
    () => (important ? ImportantIntentColors : IntentColors),
    [important]
  );

  return (
    <div className={classNames('even-status', className)}>
      <span className="even-status-icon">
        <FontAwesomeIcon
          color={colors[status ?? Intent.NONE]}
          fontSize="8px"
          icon={faCircle}
          {...iconProps}
        />
      </span>
      {children}
    </div>
  );
};
